<script>
  export let size = 'small'
</script>

<svg class="logo {size}" viewBox='0 0 59 38'>
  <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'>
  <g transform='translate(-1087.000000, -47.000000)' stroke='currentColor' stroke-width='6.99999988'>
  <g transform='translate(1091.000000, 51.000000)'>
  <path d='M12.0612904,7.17206136 C12.0612904,7.17206136 9.93605753,13.2663795 9.93605753,15.2334705 C9.93605753,17.1998568 12.0612904,23.2948795 12.0612904,23.2948795'></path>
  <path d='M50.906174,15.2334 C50.906174,23.6463773 44.1434342,30.4670818 35.8003932,30.4670818 C27.4587493,30.4670818 20.6960096,23.6463773 20.6960096,15.2334 C20.6960096,6.82042273 27.4587493,-0.000281818182 35.8003932,-0.000281818182 C44.1434342,-0.000281818182 50.906174,6.82042273 50.906174,15.2334 L50.906174,15.2334 Z'></path>
  <path d='M1.65379726,8.96407273 C1.65379726,8.96407273 0.000139726027,13.3991864 0.000139726027,15.2331182 C0.000139726027,17.0677545 1.65379726,21.5028682 1.65379726,21.5028682' ></path>
  </g>
  </g>
  </g>
</svg>

<style>
  .logo {
    color: var(--black);
  }
  .small {
    height: 32px;
  }
  .large {
    height: 64px;
  }
</style>
